import { Injectable, inject } from '@angular/core';
import { PushService } from './push.service';

/**
 * Enregistre le Service Worker push au démarrage de l'app (mais ne demande
 * pas la permission — c'est à l'utilisateur de cliquer « Activer » dans
 * Paramètres).
 *
 * <p>Le SW est utile dès l'enregistrement : il met à jour {@code subscribed$}
 * en lisant l'état existant — utile en cas de rechargement de la page après
 * souscription préalable.</p>
 */
@Injectable({ providedIn: 'root' })
export class PushBootstrap {
  private push = inject(PushService);

  init(): void {
    void this.push.registerServiceWorker();
  }
}
